import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { readOnly } from "../../core/util/Interface";
import { ToneAudioNode } from "../../core/context/ToneAudioNode";
import { optionsFromArguments } from "../../core/util/Defaults";
import { Panner } from "./Panner";
import { Volume } from "./Volume";
/**
 * PanVol is a Tone.Panner and Tone.Volume in one.
 * @example
 * // pan the incoming signal left and drop the volume
 * const panVol = new Tone.PanVol(-0.25, -12).toDestination();
 * const osc = new Tone.Oscillator().connect(panVol).start();
 * @category Component
 */

export var PanVol = /*#__PURE__*/function (_ToneAudioNode) {
  _inherits(PanVol, _ToneAudioNode);

  var _super = _createSuper(PanVol);

  function PanVol() {
    var _this;

    _classCallCheck(this, PanVol);

    _this = _super.call(this, optionsFromArguments(PanVol.getDefaults(), arguments, ["pan", "volume"]));
    _this.name = "PanVol";
    var options = optionsFromArguments(PanVol.getDefaults(), arguments, ["pan", "volume"]);
    _this._panner = _this.input = new Panner({
      context: _this.context,
      pan: options.pan,
      channelCount: options.channelCount
    });
    _this.pan = _this._panner.pan;
    _this._volume = _this.output = new Volume({
      context: _this.context,
      volume: options.volume
    });
    _this.volume = _this._volume.volume; // connections

    _this._panner.connect(_this._volume);

    _this.mute = options.mute;
    readOnly(_assertThisInitialized(_this), ["pan", "volume"]);
    return _this;
  }

  _createClass(PanVol, [{
    key: "mute",
    get:
    /**
     * Mute/unmute the volume
     */
    function get() {
      return this._volume.mute;
    },
    set: function set(mute) {
      this._volume.mute = mute;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(PanVol.prototype), "dispose", this).call(this);

      this._panner.dispose();

      this.pan.dispose();

      this._volume.dispose();

      this.volume.dispose();
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(ToneAudioNode.getDefaults(), {
        mute: false,
        pan: 0,
        volume: 0,
        channelCount: 1
      });
    }
  }]);

  return PanVol;
}(ToneAudioNode);